export default __webpack_public_path__ + "static/media/hexmountain.138eba72.png";